<template>
  <div class="root">
    <Dropdown noautohide v-model:active="app.isHandRaised">
      <template #icon>
        <font-awesome-icon icon="hand-paper" />
      </template>
    </Dropdown>

    <Dropdown icon="bxs-smile" class="!grid grid-cols-2 gap-x-2 w-[300px]">
      <div :class="{ active: isActive('🙂') }" @click="setEmoji('🙂')">🙂 Happy</div>
      <div :class="{ active: isActive('😭') }" @click="setEmoji('😭')">😭 Crying</div>
      <div :class="{ active: isActive('😵') }" @click="setEmoji('😵')">😵 Confused</div>
      <div :class="{ active: isActive('👏') }" @click="setEmoji('👏')">👏 Applause</div>
      <div :class="{ active: isActive('🤯') }" @click="setEmoji('🤯')">🤯 Mind Blown</div>
      <div :class="{ active: isActive('🫡') }" @click="setEmoji('🫡')">🫡 Salute</div>
      <div :class="{ active: isActive('💡') }" @click="setEmoji('💡')">💡 I get it!!</div>
      <div :class="{ active: isActive('🏳️') }" @click="setEmoji('🏳️')">🏳️ I give up.</div>
      <div :class="{ active: isActive('🥳') }" @click="setEmoji('🥳')">🥳 Celebration!</div>
      <div :class="{ active: isActive('🤣') }" @click="setEmoji('🤣')">🤣 LOL!!</div>
      <div :class="{ active: isActive('💀') }" @click="setEmoji('💀')">💀 Dead</div>
    </Dropdown>

    <Dropdown icon="bxs-user">
      <div :class="{ active: isActiveUserStatus('⏳') }" @click="setUserStatus('⏳')">⏳ Away / AFK</div>
      <div :class="{ active: isActiveUserStatus('🤔') }" @click="setUserStatus('🤔')">🤔 Thinking</div>
      <div :class="{ active: isActiveUserStatus('📝') }" @click="setUserStatus('📝')">📝 Taking Notes</div>
      <div :class="{ active: isActiveUserStatus('🔇') }" @click="setUserStatus('🔇')">🔇 Can't Hear / Tech. Issue</div>
    </Dropdown>

    <!-- <Dropdown icon="bx-line-chart-down">
  </Dropdown> -->

    <Dropdown icon="bxs-bar-chart-alt-2" :color="!app.feedbackVisibility ? 'red' : ''">
      <div :class="{ active: isActiveFeedback('✔️') }" @click="setFeedback('✔️')">✔️ Yes</div>
      <div :class="{ active: isActiveFeedback('😵') }" @click="setFeedback('😵')">😵 Unsure</div>
      <div :class="{ active: isActiveFeedback('❌') }" @click="setFeedback('❌')">❌ No</div>

      <div :class="{ active: !isNaN(Number(app.feedback)) }" class="flex items-center gap-2">
        <span @click="setFeedback('')" style="top: -2px; position: relative">⭐</span>
        <span style="font-size: 20px; padding: 2px">{{ feedbackRating }}</span>

        <input
          v-model="feedbackRating"
          type="range"
          min="0"
          max="10"
          @change="setFeedback(($event.target as HTMLInputElement).value)"
          class="bg-transparent! border-0!"
        />
      </div>

      <div class="divider" />

      <div :class="{ active: isActiveFeedback('👍') }" @click="setFeedback('👍')">👍 Thumbs up</div>
      <div :class="{ active: isActiveFeedback('👎') }" @click="setFeedback('👎')">👎 Thumbs down</div>

      <div
        :class="{ active: isActiveFeedback('<i class=\'bx bxs-right-arrow\'/>') }"
        @click="setFeedback('<i class=\'bx bxs-right-arrow right-arrow\' />')"
      >
        <i class="bx bxs-right-arrow right-arrow" />
        Faster
      </div>
      <div
        :class="{ active: isActiveFeedback('<i class=\'bx bxs-left-arrow\'/>') }"
        @click="setFeedback('<i class=\'bx bxs-left-arrow left-arrow\' />')"
      >
        <i class="bx bxs-left-arrow left-arrow" />
        Slower
      </div>

      <div class="divider" />

      <div v-if="app.isTeacher()" @click="setFeedbackVisibility()">
        <span v-if="app.feedbackVisibility" style="color: red">
          Hide Feedback
          <i class="bx bxs-low-vision" />
        </span>
        <span v-else style="color: green">
          Show Feedback
          <i class="bx bxs-show" />
        </span>
      </div>
    </Dropdown>
    <Dropdown v-if="app.isTeacher()" icon="bxs-music" class="sound-effects-dropdown !cursor-default" noHover noautohide>
      <div class="sound-grid">
        <template v-if="favouriteEffects.length">
          <div class="col-span-full text-sm text-gray-700">
            Recently Used
            <button class="inline-flex italic underline" @click="soundEffectUsage = {}">(reset)</button>
          </div>
          <button v-for="id in favouriteEffects" :key="id" class="sound-button" @click="setSoundEffect(id)">
            {{ sounds.find((a) => a.id === id)!.name }}
          </button>
        </template>
        <div class="col-span-full text-sm text-gray-700 mt-2">Sound Effects</div>
        <button v-for="sound in soundsFiltered" :key="sound.id" class="sound-button" @click="setSoundEffect(sound.id)">
          {{ sound.name }}
        </button>
      </div>

      <div class="control-buttons">
        <button class="stop-button" @click="setSoundEffect('')">
          <i class="bx bx-stop-circle"></i>
          Stop Sound
        </button>
        <button class="celebration-button" @click="fireWorksCelebration('A mistake we can all learn from!!')">
          <i class="bx bx-party"></i>
          Celebrate Mistake
        </button>
      </div>
    </Dropdown>
  </div>
</template>

<script lang="ts" setup>
import { onMounted, ref, watch, computed } from 'vue';
import { getApp } from '../models/App';
import Dropdown from './Dropdown.vue';
import { useLocalStorage } from '@vueuse/core';

const app = getApp();

const sounds = [
  { id: 'alert', name: 'Alert!' },
  { id: 'downer', name: 'Downer' },
  { id: 'losing', name: 'Losing' },
  { id: 'intense', name: 'Intense!' },
  { id: 'ding', name: 'Ding' },
  { id: 'bell', name: 'Bell' },
  { id: 'cheeringCrowd', name: 'Cheering Crowd' },
  { id: 'crickets', name: 'Crickets' },
  { id: 'shovelBonk', name: 'Shovel Bonk' },
  { id: 'fbiOpenUp', name: 'FBI Open Up!' },
  { id: 'success', name: 'Success!' },
  { id: 'upper', name: 'Upper' },
  { id: 'sadViolin', name: 'Sad Violin' },
  { id: 'angelicChoir', name: 'Angelic Choir' },
  { id: 'lightSaber', name: 'Light Saber' },
  { id: 'magic', name: 'Magic' },
  { id: 'ohhCrowd', name: 'Ohhhh!!!' },
  { id: 'policeSiren', name: 'Police Siren' },
  { id: 'powerUp', name: 'Power Up' },
  { id: 'doink', name: 'Doink' },
  { id: 'slap', name: 'Slap' },
  { id: 'sneaky', name: 'Sneaky' },
  { id: 'yes', name: 'Yes!!' },
  { id: 'yuck', name: 'Yuck' },
  { id: 'badumTiss', name: 'Ba Dum Tiss' },
  { id: 'gasp', name: 'Gasp!' },
  { id: 'bruh', name: 'Bruh' },
  { id: 'clapping', name: 'Clapping' },
  { id: 'crash', name: 'Crash' },
  { id: 'blueDanubeWaltz', name: 'Blue Danube Waltz' },
  { id: 'dramaticEffect', name: 'Dramatic Effect' },
  { id: 'drumRollTada', name: 'Drum Roll → Tada' },
  { id: 'dunDunDUN', name: 'Dun, DUN, DUN!!' },
  { id: 'evilLaugh', name: 'Evil Laugh' },
  { id: 'pewPew', name: 'Pew Pew' },
  { id: 'fallingBomb', name: 'Falling Bomb' },
  { id: 'laughingCrowd', name: 'Laughing 1' },
  { id: 'laughingCrowd2', name: 'Laughing 2' },
  { id: 'pacManDying', name: 'Pac Man Dying' },
  { id: 'wompwomp', name: 'Womp Womp' },
  { id: 'wrongBuzzer', name: 'Wrong Buzzer' },
  { id: 'johnCena', name: 'John Cena' },
];

const soundsFiltered = computed(() => {
  return sounds.filter((sound) => !favouriteEffects.value.includes(sound.id));
});

const setEmoji = (emoji: string) => {
  app.emoji = emoji === app.emoji ? '' : emoji;
};

const isActive = (emoji: string) => {
  return app.emoji === emoji;
};

const setFeedback = (feedback: string | number) => {
  // Reset the slider to 0 if the feedback is blank (a reset call) or if it's not a number (green check, thumbs up, etc.)
  if (feedback == '' || !Number.isInteger(parseInt(String(feedback)))) {
    feedbackRating.value = 0;
  }
  app.feedback = feedback === app.feedback ? '' : feedback;
};

const feedbackRating = ref(0);

const isActiveFeedback = (feedback: string) => {
  return app.feedback === feedback;
};

const setUserStatus = (userStatus: string) => {
  app.userStatus = userStatus === app.userStatus ? '' : userStatus;
};

const isActiveUserStatus = (userStatus: string) => {
  return app.userStatus === userStatus;
};

const raiseHand = () => {
  app.isHandRaised = !app.isHandRaised;
};

const setFeedbackVisibility = () => {
  app.feedbackVisibility = !app.feedbackVisibility;
  app.restrictedSend(`[feedbackVisibility]${app.feedbackVisibility}`);
};

watch(
  () => app.isHandRaised,
  (newValue) => {
    app.raiseHand(app.connection.id, newValue);
  },
);

watch(
  () => app.emoji,
  (value) => {
    app.setUserEmoji(app.connection.id, value);
  },
);

watch(
  () => app.feedback,
  (value) => {
    app.setUserFeedback(app.connection.id, value);
  },
);

watch(
  () => app.userStatus,
  (value) => {
    app.setUserStatus(app.connection.id, value);
  },
);

// const up = computed(() => User.all().filter(u => u.feedback === '✔️' && u.visible).length)
// const down = computed(() => User.all().filter(u => u.feedback === '❌' && u.visible).length)

// For playing/stopping a specified sound effect
const setSoundEffect = (soundName: string) => {
  if (soundName) {
    soundEffectUsage.value[soundName] = (soundEffectUsage.value[soundName] ?? 0) + 1;
  }
  app.send(`[soundEffect]${soundName}`);
};

// For displaying a firework celebration when a mistake occurs
const fireWorksCelebration = (text: string) => {
  // Send info. to the server so everyone gets the effect.
  app.send(`[fireWorksCelebration]${text}`);
};

// For catching keyboard shortcuts
onMounted(() => {
  document.addEventListener('keydown', globalKeyDown);
});

// Making keyboard shortcuts work
const globalKeyDown = (ev: KeyboardEvent) => {
  if (ev.ctrlKey) {
    // Using ev.preventDefault() below to prevent the browser from using default keyboard shortcuts that would interfere or be done concurrently with what we want below.
    // It would be better to use it here, but that prevents text from being copy/pasted in the the chat.

    if (ev.key === '1') {
      ev.preventDefault();
      setFeedback('✔️');
    }
    if (ev.key === '2') {
      ev.preventDefault();
      setFeedback('❌');
    }
    if (ev.key === '3') {
      ev.preventDefault();
      setFeedback('😵');
    }
    if (ev.key === '4') {
      ev.preventDefault();
      raiseHand();
    }
  }
};

const soundEffectUsage = useLocalStorage<Record<string, number>>('soundEffects', {});
const favouriteEffects = computed(() => {
  return Object.entries(soundEffectUsage.value)
    .sort(([_, a], [__, b]) => b - a)
    .map(([key]) => key)
    .slice(0, 5); // The 2nd argument (5, by default) sets the number of sounds that can be stored in "Recently Used"
});
</script>

<style>
.right-arrow {
  color: green;
}
.left-arrow {
  color: red;
}
</style>

<style scoped>
div.root {
  height: 32px;
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
  padding: 0 5px;
}

div.root > div {
  position: relative;
  font-size: 20px;
  width: 32px;
  height: 32px;
  text-align: center;
  line-height: 28px;
  cursor: pointer;
}

.row {
  padding: 5px;
}

.item {
  padding: 10px;
  outline: 1px solid black;
  cursor: pointer;
  width: -webkit-fill-available;
  text-align: center;
}

.item:hover {
  background: var(--color-accent-room);
}

.soundEffect {
  font-size: 16px;
  padding: 5px;
}

.stopSoundEffect {
  width: 100%;
  color: red;
  background: white;
}

.fireWorksError {
  width: 100%;
  color: blue;
  background: white;
}

.divider {
  border-top: 1px solid;
  height: 0px;
  padding: 0px !important;
  margin: 5px;
  cursor: default;
}

.sound-grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 8px;
  padding: 12px;
}

.sound-button {
  padding: 4px 6px;
  border: none;
  border-radius: 4px;
  background: var(--color-accent-icon);
  color: black;
  cursor: pointer;
  font-size: 16px;
}

.sound-button:hover {
  background: #f6d656;
}

.control-buttons {
  padding: 12px;
  display: flex;
  gap: 8px;
  border-top: 1px solid var(--color-border);
}

.stop-button {
  background: #dc3545;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 4px 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 16px;
}

.stop-button:hover {
  background: #c82333;
}

.celebration-button {
  background: #0d6efd;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 4px 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 16px;
}

.celebration-button:hover {
  background: #0b5ed7;
}
</style>
